const API_LIMIT = 1000;
export const clampLimitAndOffset = queryWithOpts => Object.assign({}, queryWithOpts, {
  reportOptions: Object.assign({}, queryWithOpts.reportOptions, {
    limit: API_LIMIT,
    offset: API_LIMIT * Math.floor((queryWithOpts.reportOptions.offset || 0) / API_LIMIT)
  })
});
export const applyLimitAndOffset = (datamap, {
  limit,
  offset = 0
}) => {
  const primaryDataset = datamap['primary'];
  const data = primaryDataset.data;
  const clampedOffset = offset % API_LIMIT;
  return Object.assign({}, datamap, {
    primary: Object.assign({}, primaryDataset, {
      data: limit ? data.slice(clampedOffset, clampedOffset + limit) : data.slice(clampedOffset)
    })
  });
};